import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "textarea", "nameField"]

  async suggest(event) {
    event.preventDefault()
    
    const link = event.currentTarget
    const nameField = this.nameFieldTarget
    const textarea = this.textareaTarget
    
    // Check if name field has a value
    if (!nameField.value.trim()) {
      alert("Please enter a classification name first")
      nameField.focus()
      return
    }
    
    this.setLoading(true)

    try {
      // Get the base URL from the link and add query parameters
      const url = new URL(link.href, window.location.origin)
      url.searchParams.set('name', nameField.value.trim())
      
      // Add parent_id if available (for nested classifications)
      const parentIdField = document.querySelector('input[name="classification[parent_id]"]')
      if (parentIdField && parentIdField.value) {
        url.searchParams.set('parent_id', parentIdField.value)
      }
      
      const response = await fetch(url, {
        headers: {
          "Content-Type": "application/json"
        }
      })

      const data = await response.json()

      if (response.ok) {
        textarea.value = data.suggestion
        textarea.focus()
      } else {
        alert(data.error || "An error occurred while generating suggestion")
      }
    } catch (error) {
      console.error("Error:", error)
      alert("An error occurred while generating suggestion")
    } finally {
      this.setLoading(false)
    }
  }

  setLoading(isLoading) {
    const link = this.linkTarget
    const spinner = link.querySelector('[data-spinner]')
    const icon = link.querySelector('[data-icon]')
    
    link.disabled = isLoading
    
    if (spinner && icon) {
      if (isLoading) {
        spinner.classList.remove("hidden")
        icon.classList.add("hidden")
      } else {
        spinner.classList.add("hidden")
        icon.classList.remove("hidden")
      }
    }
  }
} 